import { isServerSide } from "../utils";
export const getDictionary = () => {
    if (isServerSide()) {
        return {};
    }
    const meta = document.querySelector('meta[property="dictionary"]') || document.querySelector('meta[name="dictionary"]');
    const metaContent = meta === null || meta === void 0 ? void 0 : meta.getAttribute("content");
    if (metaContent) {
        try {
            return JSON.parse(metaContent);
        }
        catch (error) {
            console.warn(`Can't parse dictionary from meta[property="dictionary"]. Going to use fallback dictionary.`);
        }
    }
    return (window["__fallbackDictionary"] || {});
};
//# sourceMappingURL=dictionary.js.map